import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DatePicker } from '@ionic-native/date-picker/ngx';

@Component({
    selector: 'app-freezescreen',
    templateUrl: './freezescreen.component.html',
    styleUrls: ['./freezescreen.component.scss'],
})
export class FreezeComponent implements OnInit {
    public forgotpwdform: FormGroup;
    languageConext: any;
    currentpath;
    freezedstartTime: any;
    freezeendTime: any;
    freezerelease: any;
    freezeendtimedateformat: any

    constructor(public formBuilder: FormBuilder, private datePicker: DatePicker,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        public api: RestapiService) {
        this.currentpath = this.router.url;
        this.freezedstartTime = new Date(JSON.parse(localStorage.freezetime)).getTime();
        this.freezeendTime = new Date(this.freezedstartTime).getTime() + 900000;
        this.freezeendtimedateformat = moment(new Date(this.freezeendTime)).format('LT');
        this.handlingfreezing(this.freezedstartTime, this.freezeendTime, this.freezeendTime)
        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].freezescreen;
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].freezescreen;
            console.log(this.languageConext)
        }
    }

    ngOnInit() {
        
    }

    handlingfreezing(starttime, endtime, timetoshow) {
        var currentTime = (new Date().getTime());
        setTimeout( () => {
            if ((currentTime < endtime)) {
                this.handlingfreezing(starttime, endtime, timetoshow);
            } else {
                localStorage.removeItem("freezetime");
                localStorage.removeItem("user");
                localStorage.removeItem("dobdate");
                localStorage.removeItem("logined");
                localStorage.removeItem("role");
                localStorage.removeItem("dob");
                localStorage.removeItem("state");
                this.cmndeclaration.deleteProcess("profile");
                localStorage.removeItem("logout");
                this.cmndeclaration.deletefile();
                this.cmndeclaration.ChatFullHistory=[];
                this.cmndeclaration.ChatfullList =[];
                this.cmndeclaration.capsuleList = [];
                localStorage.removeItem("uniqueId");
                localStorage.removeItem("userChatSessionId");
                localStorage.removeItem("userSessionID");
                sessionStorage.CurrentPage = "/preRegister"
                this.navctrl.navigateRoot("/preRegister")
            }
        }, 1000);

    }
}
